import _construct from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/construct";
import { unpack, type } from '../../utils/index.js';
import chroma from '../../chroma.js';
import Color from '../../Color.js';
import input from '../input.js';
import oklab2rgb from './oklab2rgb.js';
import rgb2oklab from './rgb2oklab.js';
Color.prototype.oklab = function () {
  return rgb2oklab(this._rgb);
};
var oklab = function oklab() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return _construct(Color, args.concat(['oklab']));
};
Object.assign(chroma, {
  oklab: oklab
});
input.format.oklab = oklab2rgb;
input.autodetect.push({
  p: 2,
  test: function test() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    args = unpack(args, 'oklab');
    if (type(args) === 'array' && args.length === 3) {
      return 'oklab';
    }
  }
});
export { oklab };